import styled from 'styled-components';

export const StyledLinkableToastMessage = styled.div`
  font-size: 16px;

  .linkable-toast-message-text {
    display: inline;
    font-size: 15px;
    text-decoration: underline;
  }
`;
